import Recent from '../searchIcons/recent';
import Search from '../searchIcons/search';
import Shortlist from '../searchIcons/shortlist';
import Trending from '../searchIcons/trending';

export { Recent, Search, Shortlist, Trending };



// WEBPACK FOOTER //
// ../q-components/components/icons/searchIcons/index.js